/**
 * Based on [this algorithm](https://gist.github.com/jed/982883).
 */
export default function uuid() {
  /* eslint-disable */
  return 'b-' + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (a) {
    return (a ^ Math.random() * 16 >> a / 4).toString(16);
  });
  /* eslint-enable */
}